import { arrayMove } from 'react-sortable-hoc';
import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class HomeModel extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.listModel = {
      request: this.buildActionName('request', 'home', 'list'),
      response: this.buildActionName('response', 'home', 'list'),
      error: this.buildActionName('error', 'home', 'list'),
    };

    this.addModel = {
      request: this.buildActionName('request', 'home', 'add'),
      response: this.buildActionName('response', 'home', 'add'),
      error: this.buildActionName('error', 'home', 'add'),
    };

    this.removeModel = {
      request: this.buildActionName('request', 'home', 'remove'),
      response: this.buildActionName('response', 'home', 'remove'),
      error: this.buildActionName('error', 'home', 'remove'),
    };

    this.orderModel = {
      request: this.buildActionName('request', 'home', 'order'),
      response: this.buildActionName('response', 'home', 'order'),
      error: this.buildActionName('error', 'home', 'order'),
    };

    this.initialState = {
      isLoading: false,
      error: false,
      errorMessage: '',
      data: [],
    };
  }

  list = () => asyncFn({
    url: `${this.url}/list`, method: 'POST', model: this.listModel,
  })

  add = ({ body }) => asyncFn({
    body, url: `${this.url}/add`, method: 'POST', model: this.addModel,
  })

  remove = ({ body }) => asyncFn({
    body, url: `${this.url}/remove`, method: 'POST', model: this.removeModel,
  })

  order = ({ body }) => asyncFn({
    body, url: `${this.url}/order`, method: 'POST', model: this.orderModel,
  })

  changeOrder = props => (dispatch) => {
    dispatch({
      type: 'CHANGE_ORDER_HOME',
      ...props,
    });
  }

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case 'CHANGE_ORDER_HOME': {
        return {
          ...state,
          data: arrayMove(state.data, action.oldIndex, action.newIndex),
        };
      }
      case this.listModel.request:
        return this.requestCase(state, action);
      case this.listModel.error:
        return this.errorCase(state, action);
      case this.addModel.request:
        return this.requestCase(state, action);
      case this.addModel.error:
        return this.errorCase(state, action);
      case this.removeModel.request:
        return this.requestCase(state, action);
      case this.removeModel.error:
        return this.errorCase(state, action);
      case this.orderModel.request:
        return this.requestCase(state, action);
      case this.orderModel.error:
        return this.errorCase(state, action);
      case this.orderModel.response:
        return {
          ...state,
          isLoading: false,
        };
      case this.listModel.response:
        return {
          ...state,
          isLoading: false,
          data: action.payload.sort((a, b) => (a.order - b.order)),
        };
      case this.addModel.response:
        return {
          ...state,
          isLoading: false,
        };
      case this.removeModel.response:
        return {
          ...state,
          isLoading: false,
        };
      default: {
        return state;
      }
    }
  }
}

export default HomeModel;



// WEBPACK FOOTER //
// ./src/models/HomeModel.js